module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	]
};